// Render and validate a full name field
import React from "react";
import { useFormContext } from "react-hook-form";

const FullNameField = () => {
  const { register, formState } = useFormContext();
  return (
    <div className="component-full-name-field">
      <div className="field">
        <input
          id="full_name"
          type="text"
          placeholder=" "
          {...register("full_name", {
            required: true,
          })}
          className={
            (formState.errors.full_name && "error") ||
            (formState.dirtyFields.full_name && "valid")
          }
        />
        <label htmlFor="full_name">Full name</label>
        <span className="field-error-msg">
          {formState?.errors?.full_name?.type === "required" &&
            "Please enter your full name"}
          {formState?.errors?.full_name?.type === "api" &&
            formState?.errors?.full_name?.message}
        </span>
      </div>
    </div>
  );
};
export default FullNameField;
